import Transformer, { TRANSFORM_INPUT } from "+/Engine/Transformers/Transformer";

// Resolves the input through `crypto.randomUUID` to produce a fresh
// RFC-4122 v4 UUID. The input value is intentionally ignored — `uuidv4`
// exists so App.json routines can ask the engine to mint an id at
// execution time without having to thread one through every caller.
// Used by CreateDynamicComponent to seed `variantGroupId` so brand-new
// DCs end up as their own variant group of one.
//
// Client and server run the transformer independently, so they will
// produce different UUIDs during the optimistic window. The server's
// value becomes canonical when the response merges back. That mismatch
// is harmless for variantGroupId because nothing references it during
// the optimistic window: variant resolution only kicks in once the DC
// has been persisted.
export default class Uuidv4 extends Transformer {
  // eslint-disable-next-line no-unused-vars
  assertValidInput(value, params) {
  }

  // eslint-disable-next-line no-unused-vars
  [TRANSFORM_INPUT](value, params) {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
      return crypto.randomUUID();
    }
    const bytes = new Uint8Array(16);
    if (typeof crypto !== "undefined" && typeof crypto.getRandomValues === "function") {
      crypto.getRandomValues(bytes);
    } else {
      for (let i = 0; i < 16; i++) {
        bytes[i] = Math.floor(Math.random() * 256);
      }
    }
    const versionedByte = bytes[6] & 0x0f;
    bytes[6] = versionedByte | 0x40;
    const variantByte = bytes[8] & 0x3f;
    bytes[8] = variantByte | 0x80;
    const hex = Array.from(bytes, b => b.toString(16).padStart(2, "0")).join("");
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  }
}
Transformer.register("uuidv4", Uuidv4);
